import React from 'react'
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Chip } from '@material-ui/core';
import moment from 'moment';
import 'moment/locale/ja';

import Image from '../common/Image';
import noImageUrl from '../../img/no_image_small.jpg';

const useStyles = makeStyles((theme) => ({
    userComment: {
        display: 'flex',
        position: 'relative',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'left',
    },
    image: {
        width: '10rem',
        height: '10rem',
        borderRadius: '50%',
        overflow: 'hidden',
        margin: theme.spacing(1),
        flexShrink: 0,
        '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
        },
        [theme.breakpoints.down('sm')]: {
            width: '4rem',
            height: '4rem',
        },
    },
    status: {
        position: 'absolute',
        top: 'calc(100% / 2 - 7rem)',
        left: 0,
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.warning.contrastText,
        fontSize: '0.875rem',
        fontWeight: 600,
    },
    comment: {
        margin: theme.spacing(1),
        display: 'inline-block',
        position: 'relative',
        padding: '17px 13px',
        borderRadius: '12px',
        background: theme.palette.warning.light,
        flexGrow: 1,
    },
    mine: {
        '& $comment': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.contrastText,
        },
    },
    userName: {
        fontWeight: 700,
        fontSize: '1.4rem',
        marginBottom: theme.spacing(0.5),
    },
    commentText: {
        fontSize: '1.4rem',
        lineHeight: 1.6,
        whiteSpace: 'pre-wrap',
        marginBottom: theme.spacing(0.5),
    },
    timestamp: {
        fontSize: '1.2rem',
        color: theme.palette.info.main,
        marginTop: theme.spacing(0.5),
    },
}));

const UserComment = ({ user, status, comment, datetime }) => {
    const classes = useStyles();
    const currentUser = useSelector(state => state.user.currentUser);
    let mine = currentUser && currentUser._id === user._id;

    return (
        <Box className={`${classes.userComment} ${mine ? classes.mine : ''}`}>
            {status && (
                <Chip
                    label={status}
                    className={classes.status}
                    size="small"
                />
            )}
            <Box className={classes.image}>
                <Image
                    src={user.profile.avatar ? user.profile.avatar.image_url : noImageUrl}
                    size={'200'}
                    alt='Profile Image'
                />
            </Box>
            <Box className={classes.comment}>
                <Typography className={classes.userName}>
                    <strong>{user.name}:</strong>
                </Typography>
                <Typography className={classes.commentText}>
                    {comment}
                </Typography>
                <Typography className={classes.timestamp}>
                    {moment(datetime).utc().fromNow()}
                </Typography>
            </Box>
        </Box>
    )
}

UserComment.propTypes = {
    user: PropTypes.object.isRequired,
    status: PropTypes.string,
    comment: PropTypes.string.isRequired,
    datetime: PropTypes.string
}

export default UserComment
